import React, { useEffect, useState } from 'react';
import axios from 'axios';

import './Menu.css';

import addIcon from './../../image/add.svg';
import editIcon from './../../image/edit.png';

const Menu = ({
    setCurrentPage,
    setSelectedCategory,
    setSelectedSubCategory,
}) => {
    // категории
    const [categories, setCategories] = useState([]);

    // развернутая категория
    const [activeCategory, setActiveCategory] = useState(null);

    // получение категорий
    useEffect(() => {
        const loadingCategories = async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/categories',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );

                if (response.data.success) {
                    console.log('Категории: ', response.data.result);
                    setCategories(response.data.result);
                }
            } catch (error) {
                console.error('Ошибка при получении категорий ', error);
            }
        };
        loadingCategories();
    }, []);

    // развернуть категорию
    const handleCategoryClick = (categoryId) => {
        setActiveCategory((prevId) =>
            prevId === categoryId ? null : categoryId
        );
    };

    const handleChildClick = (event) => {
        event.stopPropagation();
    };

    // добавить категорию
    const handleAddClick = () => {
        setCurrentPage('AddPage');
    };

    // редактировать категорию
    const handleEditClick = (category) => {
        setSelectedCategory(category);
        setCurrentPage('EditPage');
    };

    // редактировать подкатегорию
    const handleEditSubCategoryClick = (subcategory) => {
        setSelectedSubCategory(subcategory);
        setCurrentPage('EditSubCategoryPage');
    };

    // добавить подкатегорию
    const handleAddSubCategoryClick = (category) => {
        setSelectedCategory(category);
        setCurrentPage('AddSubCategoryPage');
    };

    // страница категорий
    const handleMenuClick = () => {
        setCurrentPage('Menu');
    };

    // страница рекомендаций
    const handleRecommendationsClick = () => {
        setCurrentPage('Recommendations');
    };

    return (
        <div className='menu__wrapper'>
            <div className='menu__items_one'>
                <p className='menu__item_name' onClick={handleMenuClick}>
                    Категории
                </p>
                <p
                    className='menu__item_name'
                    onClick={handleRecommendationsClick}
                >
                    Рекомендации
                </p>
            </div>
            <div className='menu__items_two'>
                <div className='menu__nav'>
                    <input
                        type='text'
                        placeholder='Поиск категорий'
                        className='menu__input'
                    />
                    <div className='menu__add_btn' onClick={handleAddClick}>
                        <img src={addIcon} alt='add' />
                    </div>
                </div>
                <div className='menu__list'>
                    {categories.map((category) => (
                        <div
                            className={`menu__categories_items ${
                                activeCategory === category.id ? 'active' : ''
                            }`}
                            key={category.id}
                        >
                            <div
                                className='menu__categories_info'
                                onClick={() => handleCategoryClick(category.id)}
                            >
                                <h3 className='menu__categories_title'>
                                    {category.nameRu}
                                </h3>
                                <div className='menu__categories_buttons'>
                                    <div
                                        className='menu__categories_btn'
                                        onClick={(event) => {
                                            handleChildClick(event);
                                            handleEditClick(category);
                                        }}
                                    >
                                        Редактировать
                                    </div>
                                    <div
                                        className='menu__categories_btn'
                                        onClick={(event) => {
                                            handleChildClick(event);
                                            handleAddSubCategoryClick(category);
                                        }}
                                    >
                                        Добавить подкатегорию
                                    </div>
                                </div>
                            </div>
                            <div className='menu__subcategories_info'>
                                {category.subcategories.map((subcategory) => (
                                    <div
                                        className='menu__subcategories_items'
                                        key={subcategory.id}
                                    >
                                        <p className='menu__subcategories_title'>
                                            {subcategory.nameRu}
                                        </p>
                                        <div
                                            className='menu__subcategories_btn'
                                            onClick={(event) => {
                                                handleChildClick(event);
                                                handleEditSubCategoryClick(
                                                    subcategory
                                                );
                                            }}
                                        >
                                            <img
                                                src={editIcon}
                                                alt='edit'
                                                className='subcategories__edit'
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Menu;
